module.exports = __webpack_public_path__ + "img/feedback10-1.eba70e07.jpg";